module.exports = __webpack_public_path__ + "img/4.49827f2d.png";